import type { ReactNode } from 'react';

export type CompactTableSortDirection = 'ascending' | 'descending';

export interface CompactTableHeader {
  key: string;
  label: string;
  onSort?: () => void;
  sortDirection?: CompactTableSortDirection;
}

interface CompactTableProps {
  headers: CompactTableHeader[];
  children: ReactNode;
  label: string;
}

export function CompactTable({ headers, children, label }: CompactTableProps) {
  return (
    <div className="compact-table-wrapper">
      <table className="compact-table">
        <caption className="sr-only">{label}</caption>
        <thead>
          <tr>
            {headers.map((header) => (
              <th
                key={header.key}
                scope="col"
                aria-sort={header.onSort ? (header.sortDirection ?? 'none') : undefined}
              >
                {header.onSort ? (
                  <button
                    className="compact-table-sort-button"
                    type="button"
                    onClick={header.onSort}
                  >
                    <span>{header.label}</span>
                    <span className="compact-table-sort-indicator" aria-hidden="true">
                      {header.sortDirection === 'ascending'
                        ? '↑'
                        : header.sortDirection === 'descending'
                          ? '↓'
                          : '↕'}
                    </span>
                  </button>
                ) : header.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}
